import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';
import { date } from 'yup';
import logger from 'app/utils/logger';

const refreshToken = localStorage.getItem('refreshToken');

const transferService = {
  getTransferData: async () => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/transfer-page');

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  sendTransferType: async (data: any) => {
    try {
      const result = await httpClient.post<any>(
        `/api-web/v1/main/transfer-page?business_key=${data.businessKey}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  acc2acc: async (data: any) => {
    try {
      const result = await httpClient.post<any>(
        `/api-web/v1/main/transfer-page?business_key=${data.businessKey}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }

      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getBeneficiar: async (data: any) => {
    try {
      const result = await httpClient.post<any>(
        `/api-web/v1/main/transfer-page?business_key=${data.businessKey}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  uploadFile: async (data: any) => {
    try {
      const result = await httpClient.post<any>(`/api-web/v1/upload`, data.data, {
        // withCredentials: false,
        headers: data.headers,
      });

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getIpsData: async (data: any) => {
    try {
      const result = await httpClient.post<any>(
        `/api-web/v1/main/transfer-page?business_key=${data.businessKey}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getOrganization: async (data: any) => {
    try {
      const result = await httpClient.post<any>(`/api-web/v1/main/get_lov?business_key=${data.businessKey}`, {
        limit: 30,
        name: 'organization',
        offset: data.data.offset,
        search: data.data.search,
        popup: data.data.popup,
      });

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }
    }
  },

  getClassification: async (data: any) => {
    try {
      const result = await httpClient.post<any>(`/api-web/v1/main/get_lov?business_key=${data.businessKey}`, {
        limit: 30,
        name: 'classification_codes',
        offset: data.data.offset,
        search: data.data.search,
        popup: data.data.popup,
      });

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getSwiftCode: async (data: any) => {
    try {
      const result = await httpClient.post<any>(`/api-web/v1/main/get_lov?business_key=${data.businessKey}`, {
        limit: 30,
        name: data.data.name,
        offset: data.data.offset,
        search: data.data.search,
        bic_code: data.data.bic_code,
        currency: data.data.currency,
      });

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  sendToSign: async (data: any) => {
    try {
      const result = await httpClient.post<any>(
        `/api-web/v1/main/transfer-page?business_key=${data.businessKey}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'transfer-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useGetDataTransfer = (dataTransfer?: any) => {
  const { isLoadingSendTransferType, dataSendTransferType, sendTransferTypeMutation } = useSendTransferType();

  const {
    isLoading: isLoadingGetDataTransfer,
    data: dataGetTransfer,
    refetch: refetchGetDataTransfer,
  } = useQuery(['getDataTransfer'], transferService.getTransferData, {
    cacheTime: 0,
    onSuccess: (data) => {
      sendTransferTypeMutation({
        businessKey: data?.business_key,
        data: { transfer_type: dataTransfer.data.valuePageId },
      });
    },
  });

  return {
    isLoadingGetDataTransfer,
    dataGetTransfer,
    refetchGetDataTransfer,
    isLoadingSendTransferTypeFromGetData: isLoadingSendTransferType,
    dataSendTransferTypeFromGetData: dataSendTransferType,
  };
};

export const useSendTransferType = () => {
  const {
    isLoading: isLoadingSendTransferType,
    data: dataSendTransferType,
    mutate: sendTransferTypeMutation,
  } = useMutation(
    ['sendTransfetType'],
    (data: { data: any; businessKey: string }) => transferService.sendTransferType(data),
    {
      onError: async (err: any) => {
        if (err?.response.status === 400) {
          return err?.response.data;
        }

        if (err?.response?.status === 401) {
          window.location.href = 'login';
          localStorage.clear();
        }

        if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
          try {
            const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
            // refetchGetHeaderAndMenu();

            localStorage.setItem('refreshToken', result.refresh_token);

            window.location.href = 'transfer-page';
          } catch (errRefresh: any) {
            if (errRefresh?.response.status === 401) {
              window.location.href = 'login';
              localStorage.clear();
            }
          }
        }
      },
    }
  );

  return { isLoadingSendTransferType, dataSendTransferType, sendTransferTypeMutation };
};

export const useAcc2acc = () => {
  const {
    isLoading: isLoadingAcc2acc,
    data: dataAcc2acc,
    mutate: acc2accMutation,
  } = useMutation(['acc2acc'], (data: { data: any; businessKey: string }) => transferService.acc2acc(data));

  return { isLoadingAcc2acc, dataAcc2acc, acc2accMutation };
};

export const useGetBeneficiar = () => {
  const {
    isLoading: isLoadingGetBeneficiar,
    data: dataGetBeneficiar,
    mutate: getBeneficiarMutation,
  } = useMutation(['getBeneficiar'], (data: { data: any; businessKey: string }) => transferService.getBeneficiar(data));

  return { isLoadingGetBeneficiar, dataGetBeneficiar, getBeneficiarMutation };
};

export const useGetBeneficiarDataLocalTransfer = () => {
  const {
    isLoading: isLoadingGetBeneficiarDataLocalTransfer,
    data: dataGetBeneficiarDataLocalTransfer,
    mutate: getBeneficiarDataLocalTransferMutation,
  } = useMutation(['getBeneficiar'], (data: { data: any; businessKey: string }) => transferService.getBeneficiar(data));

  return {
    isLoadingGetBeneficiarDataLocalTransfer,
    dataGetBeneficiarDataLocalTransfer,
    getBeneficiarDataLocalTransferMutation,
  };
};
export const useFileUpload = () => {
  const {
    isLoading: isLoadingFileUpload,
    data: dataFileUpload,
    mutate: fileUploadMutation,
  } = useMutation(['fileUpload'], (data: { data: any; headers: any }) => transferService.uploadFile(data));

  return { isLoadingFileUpload, dataFileUpload, fileUploadMutation };
};

export const useGetIpsData = () => {
  const {
    isLoading: isLoadingGetIpsData,
    data: dataGetIpsData,
    mutate: getIpsDataMutation,
  } = useMutation(['getBeneficiar'], (data: { data: any; businessKey: string }) => transferService.getIpsData(data));

  return { isLoadingGetIpsData, dataGetIpsData, getIpsDataMutation };
};

export const useGetOrganization = () => {
  const {
    isLoading: isLoadingGetOrganization,
    data: dataGetOrganization,
    mutate: getOrganizationMutation,
  } = useMutation(['organization'], (data: { data: any; businessKey: string }) =>
    transferService.getOrganization(data)
  );

  return { isLoadingGetOrganization, dataGetOrganization, getOrganizationMutation };
};

export const useGetClassification = () => {
  const {
    isLoading: isLoadingGetClassification,
    data: dataGetClassification,
    mutate: getClassificationMutation,
  } = useMutation(['classification'], (data: { data: any; businessKey: string }) =>
    transferService.getClassification(data)
  );

  return { isLoadingGetClassification, dataGetClassification, getClassificationMutation };
};

export const useGetSwiftCode = () => {
  const {
    isLoading: isLoadingGetSwiftCode,
    data: dataSwiftCode,
    mutate: getSwiftCodeMutation,
  } = useMutation(['swiftCode'], (data: { data: any; businessKey: string }) => transferService.getSwiftCode(data));

  return { isLoadingGetSwiftCode, dataSwiftCode, getSwiftCodeMutation };
};

export const useSendToSign = () => {
  const {
    isLoading: isLoadingSendToSign,
    data: dataSendToSign,
    mutate: sendToSignMutation,
  } = useMutation(['sendToSign'], (data: { data: any; businessKey: string }) => transferService.sendToSign(data));

  return { isLoadingSendToSign, dataSendToSign, sendToSignMutation };
};
